import { createContext } from './createContext';
import { mlSearchSession } from '../../../shared/common/utils/mlSearchSession';
import { createApplicationState } from '../applicationState';
import { messageEventManager } from '../messageEventManager';
import { queryStringUpdater } from '../queryStringUpdater';
import { renderApplication } from '../renderApplication';

export function runApp() {
  const context = createContext();
  const store = createApplicationState(context);

  store.subscribe(() => queryStringUpdater(store.getState()));
  messageEventManager.init(store);
  mlSearchSession.init(store.getState().filters?.jsonQuery);

  renderApplication({ store, context });
}
